import React, { useEffect } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { ReactComponent as BarrierIcon } from '../svg/barrier-svgrepo-com.svg';
import { useTranslation } from 'react-i18next';


const EventNotificationContainer = ({ eventNotificationData, onClick }) => {
    useEffect(() => {
        // Wcześniejsze componentDidUpdate
        // Możesz tutaj dodać logikę reagującą na zmianę eventNotificationData
        // console.log(eventNotificationData);
    }, [eventNotificationData]);
    const { t } = useTranslation();
    let eventBackgroundColor = '';
    let eventStatus = '';

    switch (eventNotificationData?.State) {
        case 0:
            eventBackgroundColor = 'notification-notified';
            eventStatus = t('home.infoPanel.notified');
            break;
        case 1:
            eventBackgroundColor = 'notification-accepted';
            eventStatus = t('home.infoPanel.accepted');
            break;
        case 2:
            eventBackgroundColor = 'notification-edited';
            eventStatus = t('home.infoPanel.edited')
            break;
        case 3:
            eventBackgroundColor = 'notification-rejected';
            eventStatus = t('home.infoPanel.rejected');
            break;
        default:
            break;
    }

    const signature = eventNotificationData?.Signature || '';
    const contractor = eventNotificationData?.Transports?.[0]?.ContractorName || '';
    const gate = eventNotificationData?.Transports?.[0]?.GateName || '--';
    const transportsCount = eventNotificationData?.Transports?.length ?? '--';
    const transportSignature = eventNotificationData?.Transports?.[0]?.TransportSignature || '';
    let entryTime;

    try {
        const entryStart = eventNotificationData?.Transports?.[0]?.EntryStartTime?.substring(11, 16);
        const entryStop = eventNotificationData?.Transports?.[0]?.EntryStopTime?.substring(11, 16);
        entryTime = entryStart && entryStop ? `${entryStart}-${entryStop}` : '--';
    } catch {
        entryTime = '--';
    }

    return (
        <Container id={signature} className="btn p-0 mb-1 border rounded-3 shadow-sm bg-white event-container" onClick={onClick}>
            <Row className="m-0 p-0">
                <Col className={`col-auto p-2 border-end rounded-start ${eventBackgroundColor}`}></Col>
                <Col sm={2} className="border-end align-self-center text-body">
                    <p className="p-0 m-0 text-center"><i className="bi bi-calendar-event fs-5"></i></p>
                    <p className="p-0 m-0 text-center calendar-day-number-font text-break">{eventStatus}</p>
                </Col>
                <Col>
                    <Row className="m-0 p-2 align-items-center">
                        <Col className="content-font">
                            <p className="p-0 m-0 mb-1 bg-gray-100 rounded-pill border-bottom">{signature}</p>
                            <p className="p-0 m-0 bg-gray-100 rounded-pill border-bottom">{entryTime}</p>
                        </Col>
                        <Col className="border-start border-end">
                            <p className="p-0 m-0 content-font"><i className="bi bi-building fs-5"></i></p>
                            <p className="p-0 m-0 content-font bg-gray-100 rounded-pill border-bottom">{contractor}</p>
                        </Col>
                        <Col className="content-font">
                            <Row>
                                <div sm={3} className="d-flex align-items-center pb-2">
                                    <BarrierIcon width="20" height="20" />
                                    <p className="m-0 p-0 font-weight-600 lh-1 py-1 ps-3">{"  " + gate}</p>
                                </div>
                                <div sm={3} className="d-flex align-items-center border-top">
                                    <i className="bi bi-truck pe-3 fs-5"></i>
                                    <p className="m-0 p-0 text-start font-weight-600 lh-1 py-1 ">{"  " + transportsCount}</p>
                                </div>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
};

export default EventNotificationContainer;
